import React, { useState } from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { useNavigate, Link } from 'react-router-dom';

import { FiEye, FiEyeOff } from 'react-icons/fi';
import './SignUp.css';
import { API_URLS } from '../../../config/api';
import logo from '../../../images/logo.png';
const SignUp = ({ onSuccess, onClose }) => {
  const [form, setForm] = useState({
    email: '',
    password: '',
  });
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [passwordErrors, setPasswordErrors] = useState([]);

  const validatePassword = (password) => {
    return [];
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    setError('');
    setSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.password) {
      setError('Please fill in all fields.');
      return;
    }
    
    try {
      const res = await fetch(API_URLS.REGISTER, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: form.email.split('@')[0],
          email: form.email,
          password: form.password,
        }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || 'Registration error');
      } else {
        setSuccess('Registration successful!');
        if (data.token) {
          localStorage.setItem('token', data.token);
          window.dispatchEvent(new Event('storage'));
        }
        setTimeout(() => {
          if (onSuccess) {
            onSuccess(); // Call callback for modal window
          } else {
            navigate('/'); // Default redirect if not modal window
          }
        }, 1000);
      }
    } catch (err) {
      setError('Server connection error');
    }
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
        const res = await fetch(API_URLS.GOOGLE_LOGIN, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token: credentialResponse.credential }),
        });
        const data = await res.json();
        if (res.ok && data.token) {
            localStorage.setItem('token', data.token);
            window.dispatchEvent(new Event('storage'));
            navigate('/');
        } else {
            setError(data.error || 'Google login error');
        }
    } catch (err) {
        setError('Server connection error');
    }
  };

  const triggerGoogleLogin = () => {
    const googleButtonContainer = document.querySelector('.google-login-btn');
    if (googleButtonContainer) {
        const button = googleButtonContainer.querySelector('div[role="button"]');
        if (button) {
            button.click();
        }
    }
  };

  return (
    <div className="signup-page">
      <div className="signup-container">
        <div className="signup-logo">
            <img src={logo} alt="Pryvitai Logo" style={{ height: '50px' }} />
        </div>
        <h2>Create Profile</h2>

       
{/*        
        <GoogleOAuthProvider clientId="411952234902-th0g5fji6s9cept1tkqmdn8qj5brivhc.apps.googleusercontent.com">
          <GoogleLogin
            onSuccess={credentialResponse => {
              fetch(API_URLS.GOOGLE_AUTH, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ credential: credentialResponse.credential })
              })
                .then(res => res.json())
                .then(data => {
                  if (data.token) {
                    localStorage.setItem('token', data.token);
                    window.dispatchEvent(new Event('storage'));
                    
                    if (onSuccess) {
                      onSuccess(); // Викликаємо callback для модального вікна
                    } else {
                      navigate('/'); // Стандартне перенаправлення якщо не модальне вікно
                    }
                  } else {
                    alert(data.error || 'Google registration error');
                  }
                });
            }}
            onError={() => {
              console.log('Google Sign Up Failed');
            }}
            text="signup"
          />
        </GoogleOAuthProvider>
     
       

        <div className="divider">OR</div> */}

        <form className="signup-form" onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="name@example.com"
              value={form.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="input-group">
            <label htmlFor="password">Password</label>
            <div className="password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                placeholder="Create password"
                value={form.password}
                onChange={handleChange}
                required
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
          </div>
          
          {error && <p className="error-message">{error}</p>}
          {success && <p className="success-message">{success}</p>}

          <button type="submit" className="submit-btn">Create Account</button>
        </form>

        <p className="login-link">
          Already have an account? <Link to="/SignIn">Sign In</Link>
        </p>
      </div>
    </div>
  );
};

export default SignUp;
